
import { segmentEventTracking } from '@/utils/tracking'
import { TenantUser } from '@/store/modules/app/types'
import { Namespace } from '@/store/types'
import { Component, Vue } from 'vue-property-decorator'
import { State } from 'vuex-class'

@Component
export default class UserProfileVue extends Vue {
  @State('tenantUsers', { namespace: Namespace.App })
  public tenantUsers!: TenantUser[]

  private showTechnicalDetails: boolean = false

  private get profile(): any { return this.$auth0.user }
  private get accessToken(): string { return this.$auth0.accessToken }
  private get tenants(): any[] { return this.$auth0.tenants }
  private get uid(): number { return this.$auth0.uid }
  private get idToken(): string { return this.$auth0.idTokenRaw }

  // Heuristic split: assumes Western "First Last" ordering on profile.name and is
  // only used as a fallback when given_name / family_name are missing from Auth0.
  // Multi-word last names ("Mary Jane Smith") collapse into the lastName slot.
  private get nameParts(): string[] {
    return this.profile?.name?.split(' ') ?? []
  }

  private get displayName(): string {
    const tenantUser = this.tenantUsers?.find((u: TenantUser) => u.Uid === this.uid)
    return tenantUser?.name || this.profile?.name || this.profile?.email
  }

  private get firstName(): string {
    return this.profile?.given_name || this.nameParts[0] || ''
  }

  private get lastName(): string {
    return this.profile?.family_name || this.nameParts.slice(1).join(' ') || ''
  }

  private setShowTechnicalDetails(show: boolean) {
    this.showTechnicalDetails = show
    this.$gtm.trackEvent({ action: 'ShowTechnicalDetails', category: 'UserProfile', label: 'Toggle Show Technical Details', value: show })
    segmentEventTracking('UserProfile', {
      action: 'ShowTechnicalDetails',
      label: 'ToggleShowTechnicalDetails',
      value: show,
    })
  }
}
